var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyThumbsDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2996 7.58594C14.2996 8.27629 13.7399 8.83594 13.0496 8.83594C12.3592 8.83594 11.7996 8.27629 11.7996 7.58594V2.58594C11.7996 1.89558 12.3592 1.33594 13.0496 1.33594C13.7399 1.33594 14.2996 1.89558 14.2996 2.58594V7.58594Z",
    fill: "#70758F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9663 7.72483V3.19933C10.9663 2.56804 10.6096 1.99094 10.0449 1.70862L10.0034 1.68785C9.54056 1.45642 9.03018 1.33594 8.5127 1.33594L3.99926 1.33594C3.2048 1.33594 2.52077 1.8967 2.36496 2.67574L1.36496 7.67574C1.1587 8.70706 1.94752 9.66927 2.99926 9.66927H5.96626V13.0026C5.96626 13.9231 6.71245 14.6693 7.63292 14.6693C8.09316 14.6693 8.46626 14.2962 8.46626 13.8359V13.2804C8.46626 12.5591 8.70018 11.8574 9.13292 11.2804L10.2996 9.72483C10.7323 9.14784 10.9663 8.44606 10.9663 7.72483Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyThumbsDown);
export default __webpack_public_path__ + "static/media/grey-thumbs-down.27435bf898579f32f35701c64a92bfcc.svg";
export { ForwardRef as ReactComponent };